export const dataHooks = {
  tooltip: 'infoicon-tooltip',
};

export const FOCUSABLE_SELECTOR =
  'a[href], button, input, textarea, select, [tabindex]:not([tabindex="-1"])';
